import CannotAuth from "../Components/Login/CannotAuth.mjs";
import MainMenu from "../Components/BaseLayout/MainMenu.mjs";
import appLib from "./appLib.mjs";
import Glob from "./Glob.mjs";
import UsersManagement from "../Components/Administration/UsersManagement/UsersManagement.mjs";
import LogView from "../Components/Administration/LogView/LogView.mjs";
import Perimeters from "../Components/Perimeters/Perimeters/Perimeters.mjs";
import SynthUpload from "../Components/Perimeters/SynthUpload/SynthUpload.mjs";
import RealPeriUpload from "../Components/Perimeters/RealPeriUpload/RealPeriUpload.mjs";
import CveExplorer from "../Components/CpeCve/CveExplorer/CveExplorer.mjs";
import SynthGen from "../Components/Perimeters/SynthGen.mjs";
import Simulations from "../Components/Simulations/Simulations.mjs";
import CveLoader from "../Components/CpeCve/CveLoader/CveLoader.mjs";
import SimulationFlowNew from "../Components/Simulations/SimulationFlow/SimulationFlowNew.mjs";
import SimulationFlowEdit from "../Components/Simulations/SimulationFlow/SimulationFlowEdit.mjs";
import CveList from "../Components/CpeCve/CveList/CveList.mjs";

/** @type {AppPageRouter} */
const appPageRouter= (page) => {
	const ul = Glob.getStatus('userLogin');
	Glob.setStatus("ModifiersPressed", [] );
	/* Unprotected pages */
	switch (page?.name) {
		case 'CannotAuth': return <CannotAuth  {...page.params} />;
		default: break;
	}
	/* For all protected pages */
	if ( ! ul ) {
		setTimeout( appLib.verifySession );
		return null;
	}
	/* Admin pages */
	if ( appLib.admin() ) {
		switch ( page?.name ) {
			case 'UsersManagement': return <UsersManagement  {...page.params} />;
			case 'LogView': return <LogView  {...page.params} />;
			default: break;
		}
	}
	/* Regular users protected pages */
	if ( appLib.enabled() ) {
		switch (page?.name) {
      case "Simulations": return <Simulations {...page.params} />;
			case "SynthUpload": return <SynthUpload {...page.params} />;
			case "RealPeriUpload": return <RealPeriUpload {...page.params} />;
			case "SynthGen": return <SynthGen {...page.params} />;
			case "CveLoader": return <CveLoader {...page.params} />;
			case "SimulationFlowNew": return <SimulationFlowNew {...page.params} />;
			case "SimulationFlowEdit": return <SimulationFlowEdit {...page.params} />;
			default: break;
		}
	}
	/* Other protected pages (viewer) */
	switch (page?.name) {
		case "MainMenu": return <MainMenu {...page.params} />;
		case "Perimeters": return <Perimeters {...page.params} />;
		case "CveExplorer": return <CveExplorer {...page.params} />;
		case "CveList": return <CveList {...page.params} />;
		default: break;
	}
	return <MainMenu {...page.params} />;
}

export default appPageRouter;
